<template>
  <div class="confrontationRecord">
    <div class="teamInfors">
      <span
        class="teamInfors_cell"
        v-for="team in datas.objectInfo"
        :key="team.teamId"
      >
        <span class="teamInfors_teamName" v-text="team.teamName"></span>
        <span class="teamInfors_teamLogo">
          <img :src="team.teamLogo" />
        </span>
      </span>
    </div>
    <div class="record_box" v-if="recordArr && recordArr.length > 0">
      <span class="record_clo" v-for="item in recordArr" :key="item.key">
        <span class="recordClo_bgColor" v-text="item.val"></span>
        <span class="recordClo_text" v-text="item.name"></span>
      </span>
    </div>
    <div class="barList_box" v-if="barList && barList.length > 0">
      <div class="barItem_row" v-for="item in barList" :key="item.key">
        <span class="row_title" v-text="item.name"></span>
        <span class="row_main">
          <span class="left">
            <span
              class="bar_val"
              v-text="item.val[0] || item.val[0] === 0 ? item.val[0] : ''"
            ></span>
            <span class="bar_bgColor">
              <i class="bar_perColor" :style="{ width: `${item.per[0]}%` }"></i>
            </span>
          </span>
          <span class="right">
            <span
              class="bar_val"
              v-text="item.val[1] || item.val[1] === 0 ? item.val[1] : ''"
            ></span>
            <span class="bar_bgColor">
              <i class="bar_perColor" :style="{ width: `${item.per[1]}%` }"></i>
            </span>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
// 交锋记录 主题
// import canvasToImage_base64_data_mixin from '@mixins/canvasToImage_base64_data'
export default {
  name: 'confrontationRecord',
  //   mixins: [canvasToImage_base64_data_mixin],
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        title: '',
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    isAutoExportPng: {
      //是否导出图片页面使用
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      recordArr: null,
      barList: null,
    }
  },
  watch: {
    datas(val) {
      setTimeout(() => {}, 10)
    },
  },
  created() {
    this.handerDatas(this.datas)
  },
  mounted() {
    this.$nextTick(() => {
      //   const teamInfor = this.datas.objectInfo
      //   setTimeout(() => {
      //     this.datas.data.dataList.forEach((data, i) => {
      //       if (i == 0) {
      //         this.initChart(
      //           this.$refs.echartDom_home,
      //           teamInfor[i],
      //           data,
      //           this.isAutoExportPng
      //         )
      //       } else {
      //         this.initChart(
      //           this.$refs.echartDom_away,
      //           teamInfor[i],
      //           data,
      //           this.isAutoExportPng
      //         )
      //       }
      //     })
      //   }, 10)
    })
  },
  methods: {
    handerDatas(datas) {
      const recordArr = []
      const recordKey = ['homeWin', 'draw', 'awayWin']
      recordKey.forEach((key) => {
        datas.statisticsModels.forEach((keyItem) => {
          if (key == keyItem.statisticalEn) {
            recordArr.push({
              name: keyItem.name,
              key: key,
              val: datas.data[key],
            })
          }
        })
      })
      this.recordArr = recordArr

      const barList = []
      const barKey = ['goals', 'assists', 'shotsPenalty']
      barKey.forEach((key) => {
        let name = ''
        const val = []
        const per = []
        const maxVal = datas.data.maxList
        datas.statisticsModels.forEach((keyItem) => {
          if (key == keyItem.statisticalEn) {
            name = keyItem.name
            datas.data.dataList.forEach((dataItem) => {
              const teamVal = dataItem[key]
              console.debug('teamVal:', teamVal, 'maxVal[key]:', maxVal[key])
              const perVal =
                teamVal && teamVal > 0 && maxVal[key] && maxVal[key] > 0
                  ? ((teamVal / maxVal[key]) * 100).toFixed(2)
                  : 0
              val.push(teamVal)
              per.push(perVal)
            })
          }
        })

        barList.push({
          name,
          key: key,
          val,
          per,
        })
      })

      this.barList = barList
      console.debug('barList:', barList)
    },
  },
}
</script>

<style lang="scss" scoped>
.confrontationRecord {
  position: relative;
  width: 80%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .teamInfors {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    .teamInfors_cell {
      width: 50%;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      .teamInfors_teamName {
        width: auto;
        max-width: calc(100% - 2.778vw);
        font-size: 1.25vw;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        color: rgba(0, 0, 0, 0.65);
      }
      .teamInfors_teamLogo {
        width: 2.778vw;
        height: 2.778vw;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      &:first-child {
        .teamInfors_teamName {
          padding-right: 0.694vw;
        }
      }
      &:nth-child(2) {
        flex-direction: row-reverse;
        .teamInfors_teamName {
          padding-left: 0.694vw;
        }
      }
    }
  }
  .record_box {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    .record_clo {
      padding: 1.388vw 0 1.736vw 0;
      width: 5.556vw;
      .recordClo_bgColor {
        display: block;
        width: 100%;
        height: 1.25vw;
        line-height: 1.25vw;
        font-size: 0.972vw;
        text-align: center;
        color: #fff;
        background-color: rgba(201, 86, 138, 1);
        &:nth-child(2n) {
          background-color: rgba(113, 199, 191, 1);
        }
      }
      .recordClo_text {
        display: block;
        width: 100%;
        line-height: 2.083vw;
        font-size: 0.972vw;
        text-align: center;
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }

  .barList_box {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    color: rgba(0, 0, 0, 0.85);
    .barItem_row {
      width: 100%;
      .row_title {
        display: block;
        width: 100%;
        font-size: 0.833vw;
        text-align: center;
      }
      .row_main {
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        .left,
        .right {
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          align-items: center;
          width: 50%;
        }
        .left {
          .bar_val {
            text-align: left;
          }
          .bar_bgColor {
            border-radius: 1px 0 0 1px;
            .bar_perColor {
              right: 0;
              border-radius: 1px 0 0 1px;
              background-color: rgba(113, 199, 191, 1);
            }
          }
        }
        .right {
          flex-direction: row-reverse;
          .bar_val {
            text-align: right;
          }
          .bar_bgColor {
            border-radius: 0 1px 1px 0;
            .bar_perColor {
              left: 0;
              border-radius: 0 1px 1px 0;
              background-color: rgba(201, 86, 138, 1);
            }
          }
        }
        .bar_val {
          width: 2.778vw;
          font-size: 1.25vw;
          font-weight: bold;
        }
        .bar_bgColor {
          position: relative;
          width: calc(100% - 2.778vw);
          height: 0.278vw;
          background-color: rgba(216, 216, 216, 1);
          .bar_perColor {
            display: block;
            position: absolute;
            top: 0;
            z-index: 2;
            /* width: 50%; */
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
